<template>
  <div class="card stats-card">
    <div class="icon-container">
      <i class="yuzu-icon" :class="icon" />
    </div>
    <div class="stats">
      <div class="primary-block">
        <span class="number" v-text="stats?.current_month.toString() || '...'" />
        <span class="label" v-text="label" />
      </div>
      <div class="progress-block">
        <span class="muted" v-text="$t('app.home.lastMonthTotal')" />
        <span class="progress-number bold" v-text="stats?.previous_month.toString() || '...'" />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
    required: true,
  },
  stats: {
    type: [Object, null],
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});
</script>
